/*
  orlea-galerie.js — Carrousel produit maison (remplace Swiper).
  Custom element <orlea-gallery> : piste scroll-snap CSS + points.
  Depuis le 2026-08-07 (maquette v3 validee par Simon), cette galerie sert
  DESKTOP ET MOBILE : fleches ‹ › au desktop (orlea-galerie-fleches.css),
  swipe + dots au mobile. Re-hydratation via connectedCallback.
  Degradation : sans JS, la piste reste une bande d'images defilable.

  SYNCHRO GALERIE <-> TEINTE (2026-08-07, retour test mere de Simon) :
  - Slider la galerie -> selectionne la teinte correspondante.
  - Choisir une teinte -> amene la galerie sur la bonne image (saut direct).
  - Le nom de la teinte s'affiche en PASTILLE verre depoli (style A) EN HAUT
    A DROITE de l'image (orlea-teinte-nom.css v3) — position 100% CSS, aucun
    calage inline (l'ancien _calerNom posait un bottom inline, retire).

  🔑 MAPPING PAR NOM, PAS PAR INDEX. La slide 0 est TOUJOURS l'image de la teinte
  selectionnee (featured_media), donc l'ordre des slides depend de la teinte
  active et change a chaque re-render Flaunt. On mappe donc slide <-> teinte par
  le NOM lu dans le alt/aria-label (« <Produit> — <Teinte> »), qui correspond au
  value="<Teinte>" des radios. Robuste au re-render et a l'ordre.

  GARDE-FOU ANTI-BOUCLE : _syncEnCours. Un scroll declenche par une selection de
  teinte ne doit pas re-selectionner ; une selection declenchee par un slide ne
  doit pas re-scroller.
*/
(function () {
  'use strict';

  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;

  /* Nom de teinte a partir d'un alt/aria-label « Produit — Teinte ». */
  function teinteDepuisTexte(txt) {
    if (!txt) return '';
    var parts = txt.split(/[—–-]/);
    return parts.length > 1 ? parts[parts.length - 1].trim() : txt.trim();
  }

  /* Comparaison tolerante (minuscules, sans accents, espaces reduits). */
  function pliable(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }

  /* L'etiquette + la synchro ne s'appliquent QU'AUX produits a teintes. */
  function aDesTeintes() {
    return !!document.querySelector('.orlea-pdp-shades input[type="radio"]');
  }

  class OrleaGallery extends HTMLElement {
    connectedCallback() {
      this._track = this.querySelector('[data-ogal-track]');
      if (!this._track) return;
      this._slides = Array.prototype.slice.call(this._track.children);
      this._syncEnCours = false;

      this._buildNom();
      this._majNomDesktop();

      if (this._slides.length <= 1) {
        this._cleanupDots();
        this._majNom(0);
        return;
      }
      this._buildDots();
      this._buildArrows();
      this._observe();
      this._wireVideos();
      this._wireVariant();
      this._majNom(0);
    }

    /* Fleches ‹ › (desktop seulement — CSS orlea-galerie-fleches.css). */
    _buildArrows() {
      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('.ogal-arw'), function (a) { a.remove(); });
      if (this._slides.length <= 1) return;
      function faire(cls, delta, label, fleche) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ogal-arw ' + cls;
        b.setAttribute('aria-label', label);
        b.textContent = fleche;
        b.addEventListener('click', function () {
          var i = (self._active || 0) + delta;
          if (i < 0) i = self._slides.length - 1;
          if (i >= self._slides.length) i = 0;
          self._goToSlide(i);
        });
        self.appendChild(b);
      }
      faire('ogal-arw--prev', -1, FR ? 'Image precedente' : 'Previous image', '‹');
      faire('ogal-arw--next', 1, FR ? 'Image suivante' : 'Next image', '›');
    }

    /* Etiquette-pastille sur la grande image desktop (.main_stack) —
       encore utile si le stack desktop est affiche quelque part. */
    _majNomDesktop() {
      var stack = document.querySelector('.orlea-pdp-media .product_media.main_stack');
      if (!stack) return;
      var img = stack.querySelector('img');
      var nom = img ? teinteDepuisTexte(img.getAttribute('alt')) : '';
      var el = stack.querySelector('.oteinte-nom');
      if (this._slides.length > 1 && nom && aDesTeintes()) {
        if (!el) {
          el = document.createElement('span');
          el.className = 'oteinte-nom';
          el.setAttribute('aria-hidden', 'true');
          stack.appendChild(el);
        }
        el.textContent = nom;
        el.classList.add('is-on');
      } else if (el) {
        el.remove();
      }
    }

    disconnectedCallback() {
      if (this._io) { this._io.disconnect(); this._io = null; }
      if (this._onVariantChange) { document.removeEventListener('change', this._onVariantChange, true); }
    }

    _buildNom() {
      var old = this.querySelector('.oteinte-nom');
      if (old) old.remove();
      var el = document.createElement('span');
      el.className = 'oteinte-nom';
      el.setAttribute('aria-hidden', 'true');
      this.appendChild(el);
      this._nom = el;
    }

    _texteSlide(i) {
      var s = this._slides[i];
      if (!s) return '';
      var a = s.querySelector('a[aria-label]');
      if (a && a.getAttribute('aria-label')) return a.getAttribute('aria-label');
      var img = s.querySelector('img[alt]');
      if (img && img.getAttribute('alt')) return img.getAttribute('alt');
      return '';
    }

    _majNom(i) {
      if (!this._nom) return;
      var nom = teinteDepuisTexte(this._texteSlide(i));
      if (nom && this._slides.length > 1 && aDesTeintes()) {
        this._nom.textContent = nom;
        this._nom.classList.add('is-on');
      } else {
        this._nom.textContent = '';
        this._nom.classList.remove('is-on');
      }
    }

    _cleanupDots() {
      var old = this.querySelector('.ogal-dots');
      if (old) old.remove();
    }

    _buildDots() {
      this._cleanupDots();
      var dots = document.createElement('div');
      dots.className = 'ogal-dots';
      dots.setAttribute('role', 'tablist');
      this._dots = [];
      for (var i = 0; i < this._slides.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ogal-dot';
        b.setAttribute('aria-label', 'Image ' + (i + 1));
        b.dataset.i = i;
        b.addEventListener('click', this._goToSlide.bind(this, i));
        dots.appendChild(b);
        this._dots.push(b);
      }
      this.appendChild(dots);
      this._setActive(0);
    }

    _goToSlide(i) {
      if (i < 0 || i >= this._slides.length) return;
      this._track.scrollTo({ left: i * this._track.clientWidth, behavior: 'smooth' });
    }

    _observe() {
      if (this._io) this._io.disconnect();
      var self = this;
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            var idx = self._slides.indexOf(en.target);
            if (idx > -1) self._setActive(idx);
          }
        });
      }, { root: this._track, threshold: [0.6] });
      this._slides.forEach(function (s) { self._io.observe(s); });
    }

    _setActive(i) {
      if (this._active === i) return;
      this._active = i;
      if (this._dots) {
        for (var k = 0; k < this._dots.length; k++) {
          this._dots[k].classList.toggle('is-active', k === i);
        }
      }
      this._majNom(i);
      if (!this._syncEnCours) {
        this._selectTeinte(this._texteSlide(i));
      }
    }

    _selectTeinte(texteSlide) {
      var nom = pliable(teinteDepuisTexte(texteSlide));
      if (!nom) return;
      var radios = document.querySelectorAll('.orlea-pdp-shades input[type="radio"]');
      for (var k = 0; k < radios.length; k++) {
        var r = radios[k];
        if (pliable(r.value) === nom) {
          if (r.checked) return;
          this._syncEnCours = true;
          var label = r.nextElementSibling && r.nextElementSibling.classList.contains('swatch_label')
            ? r.nextElementSibling
            : document.querySelector('label[for="' + r.id + '"]');
          if (label) { label.click(); } else { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
          var self = this;
          setTimeout(function () { self._syncEnCours = false; }, 350);
          return;
        }
      }
    }

    _wireVariant() {
      var self = this;
      this._onVariantChange = function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio') return;
        if (!t.closest || !t.closest('.orlea-pdp-shades')) return;
        setTimeout(function () { self._majNomDesktop(); }, 250);
        if (self._syncEnCours) return;
        self._allerVersTeinte(t.value);
      };
      document.addEventListener('change', this._onVariantChange, true);
    }

    _allerVersTeinte(valueTeinte) {
      var nom = pliable(teinteDepuisTexte(valueTeinte));
      if (!nom) return;
      for (var i = 0; i < this._slides.length; i++) {
        if (pliable(teinteDepuisTexte(this._texteSlide(i))) === nom) {
          this._syncEnCours = true;
          this._track.scrollTo({ left: i * this._track.clientWidth, behavior: 'instant' });
          this._setActiveDirect(i);
          var self = this;
          setTimeout(function () { self._syncEnCours = false; }, 350);
          return;
        }
      }
    }

    _setActiveDirect(i) {
      this._active = i;
      if (this._dots) {
        for (var k = 0; k < this._dots.length; k++) {
          this._dots[k].classList.toggle('is-active', k === i);
        }
      }
      this._majNom(i);
    }

    _wireVideos() {
      var vids = this.querySelectorAll('video');
      Array.prototype.forEach.call(vids, function (v) {
        var play = v.parentElement && v.parentElement.querySelector('.product_video_play');
        v.addEventListener('click', function () {
          if (v.paused) { v.play(); if (play) play.style.display = 'none'; }
          else { v.pause(); if (play) play.style.display = ''; }
        });
      });
    }
  }

  if (!customElements.get('orlea-gallery')) {
    customElements.define('orlea-gallery', OrleaGallery);
  }
})();